// @ vendors
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
// @ helpers
const { getControlDigitFromCodBban } = require('utilities/ibanHelper');
const { EURO_TEXT } = require('constants/index');

const requestTaxesAndRentsInProgress = () => ({
    type: actionTypes.TAXES_AND_RENTS_IN_PROGRESS
});

const requestTaxesAndRentsSuccess = (data) => ({
    type: actionTypes.TAXES_AND_RENTS_SUCCESS,
    payload: {
        users: get(data, 'lista.dato', [])
    }
});

const requestTaxesAndRentsSuccessDetails = (data, id) => ({
    type: actionTypes.TAXES_AND_RENTS_SUCCESS_DETAIL,
    payload: {
        details: data,
        id
    }
});

const requestTaxesAndRentsFailure = (error) => ({
    type: actionTypes.TAXES_AND_RENTS_FAILURE,
    payload: {
        error
    }
});

const setAccountNumber = (accountNumber, controlDigit, accountId) => ({
    type: actionTypes.TAXES_AND_RENTS_CHANGE_ACCOUNT,
    payload: {
        accountNumber,
        controlDigit,
        accountId
    }
});

const postGetDetails = (idTaxReturn) => (dispatch, getState) => {
    const taxAndRents = getState().taxAndRents;
    const taxReturn = taxAndRents.getIn(['byId', idTaxReturn]);

    const requestData = {
        query: {
            cuenta: {
                digitodecontrol: taxAndRents.get('controlDigit'),
                numerodecuenta: taxAndRents.get('accountNumber')
            },
            listaModelo: {
                dato: [
                {
                    documentoNif: taxReturn.get('document'),
                    importeDec: {
                        divisa: taxReturn.getIn(['amount', 'currency']),
                        importe: taxReturn.getIn(['amount', 'amount']),
                    },
                    modelo:  taxReturn.get('model'),
                    numReferencia:  taxReturn.get('reference'),
                    per:  taxReturn.get('period'),
                    tipoDeclaracion: taxReturn.get('type')
                }]
            }
        }
    };

    return APIPost(dispatch, apiURLBuilder.getURL('taxAndRentsDetails'), requestData)
        .then( response => dispatch(requestTaxesAndRentsSuccessDetails(response, idTaxReturn)))
        .catch(response => dispatch(requestTaxesAndRentsFailure(response.error)));
}

const getTaxesAndRents = accountId => (dispatch, getState) => {
    const immLogin = getState().okLogin;
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const usernameType = immLogin.get('usernameType');
    const username = immLogin.get('username');
    const name = immLogin.get('name');
    const iban = immAccount.getIn(['ibanComplex', 'codbban']);
    const controlDigit = getControlDigitFromCodBban(iban)
    const accountNumber = immAccount.get('product') + immAccount.get('contractNumber');

    const requestData = {
        query: {
            digitoControl:controlDigit,
            numeroCuenta:accountNumber,
            codigoDoc:username,
            tipoDoc:usernameType,
            divisa: EURO_TEXT,
            importe:0,
            titular:name
        }
    };

    dispatch(requestTaxesAndRentsInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('taxAndRentsAccounts'), requestData)
        .then( response => {
            dispatch(requestTaxesAndRentsSuccess(response));
        })
        .catch(response => dispatch(requestTaxesAndRentsFailure(response.error)))
}

module.exports = {
    getTaxesAndRents,
    setAccountNumber,
    postGetDetails
};
